import { render } from "./redirectAlert.vue?vue&type=template&id=73025b1e"
import script from "./redirectAlert.vue?vue&type=script&lang=js"
export * from "./redirectAlert.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__